import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';

interface IChildFormControlFeeBackProps {
    type?: "valid" | "invalid";
    messages?: string | string[],
};

export default function ChildFormControlFeedBack(props: IChildFormControlFeeBackProps): ReactElement {
    const { type, messages } = props;
    let displayedMessage: string = "";
    if (messages && Array.isArray(messages)) {
        messages.forEach((msg: string) => {
            displayedMessage = displayedMessage.concat(!displayedMessage ? "" : ". ", msg)
        });
    } else if (messages) {
        displayedMessage = messages;
    }
    
    return <Form.Control.Feedback type={type}>{displayedMessage}</Form.Control.Feedback>
};

ChildFormControlFeedBack.defaultProps = {
    type: "invalid"
};